/* angular:styles/component:css;7b766ea22e098c90526162fd3b4f8cf663621f780237757a58245c2af1e30ff6;/opt/atlassian/pipelines/agent/build/src/app/tab-calculated-signals/edit-calculated-signal.component.ts */
.error-box {
  border: 1px solid var(--ion-color-danger);
  border-radius: 4px;
  padding: 4px;
}
.success-box {
  border: 1px solid var(--ion-color-success);
  border-radius: 4px;
  padding: 4px;
}
.keypad-btn {
  margin: 2px;
  font-weight: bold;
  width: 100%;
  height: 100%;
}
.popover-btn-label {
  font-size: 0.9em;
  white-space: normal !important;
}
/*# sourceMappingURL=edit-calculated-signal.component.css.map */
